import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDXWibzEYJS_2QA7GXhDca9NT_Sw_d7sYU",
  authDomain: "papi-firebase.firebaseapp.com",
  projectId: "papi-firebase",
  storageBucket: "papi-firebase.appspot.com",
  messagingSenderId: "282941207335",
  appId: "1:282941207335:web:274822dfd0d73ffaff2f02",
  measurementId: "G-LZK80LQ024"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Function to register Service Worker before calling `getToken()`
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.log("🔥 Service Worker registered:", registration);
      return registration;
    } catch (error) {
      console.error("🚨 Service Worker registration failed:", error);
      return null;
    }
  } else {
    console.warn("❌ Service Workers are not supported in this browser.");
    return null;
  }
};

// ✅ Initialize Firebase Messaging only if the browser supports it
export const messaging = (
  typeof isSupported === "function" &&
  isSupported() &&
  "Notification" in window &&
  "serviceWorker" in navigator &&
  "PushManager" in window
)
  ? getMessaging(app)
  : null;

// ✅ Function to Generate Token
export const generateToken = async () => {
  if (!messaging) {
    console.error("❌ Messaging is not initialized due to unsupported browser features.");
    return;
  }

  try {
    console.log("🔔 Requesting notification permission...");
    const permission = await Notification.requestPermission();
    console.log("Permission result:", permission);

    if (permission === "granted") {
      console.log("✅ Permission granted! Registering Service Worker...");

      // ✅ Register the Service Worker Before Fetching Token
      const registration = await registerServiceWorker();

      if (!registration) {
        console.error("🚨 Service Worker registration failed. Cannot get token.");
        return;
      }

      console.log("🔑 Fetching FCM Token...");
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID
      });

      if (token) {
        console.log("🔥 FCM Token:", token);
        return token;
      } else {
        console.error("❌ No FCM Token received.");
      }
    } else {
      console.error("❌ Notification permission not granted.");
    }
  } catch (err) {
    console.error("🚨 Error getting token:", err);
  }
};
